import { render } from "./ModalUserRoles.vue?vue&type=template&id=536dd824&scoped=true"
import script from "./ModalUserRoles.vue?vue&type=script&lang=js"
export * from "./ModalUserRoles.vue?vue&type=script&lang=js"

import "./ModalUserRoles.vue?vue&type=style&index=0&id=536dd824&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536dd824"]])

export default __exports__